import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function DirectInquiry() {
  return <section data-section-id="227630" id="direct-inquiry" className="bg-muted text-foreground relative py-24 md:py-32 px-4 md:px-8 min-h-[70vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-5 pointer-events-none" />

      {}
      <div className="relative w-full max-w-5xl border-2 border-primary/20 bg-background/80 backdrop-blur-md p-10 md:p-20 lg:p-28 flex flex-col items-center justify-center text-center z-10 shadow-lg">
        
        {}
        <div className="absolute top-0 left-0 w-8 md:w-12 h-8 md:h-12 border-t-4 border-l-4 border-primary -translate-x-[2px] -translate-y-[2px]" />
        <div className="absolute top-0 right-0 w-8 md:w-12 h-8 md:h-12 border-t-4 border-r-4 border-primary translate-x-[2px] -translate-y-[2px]" />
        <div className="absolute bottom-0 left-0 w-8 md:w-12 h-8 md:h-12 border-b-4 border-l-4 border-primary -translate-x-[2px] translate-y-[2px]" />
        <div className="absolute bottom-0 right-0 w-8 md:w-12 h-8 md:h-12 border-b-4 border-r-4 border-primary translate-x-[2px] translate-y-[2px]" />

        {}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-bold text-primary mb-12 tracking-tight leading-tight max-w-3xl">
          Need a Bulk Quotation for Marine Parts?
        </h2>

        {}
        <div className="relative group mt-4">
          {}
          <div className="absolute -inset-2 bg-primary/10 rounded-md blur-lg transition-all duration-500 group-hover:bg-primary/20 group-hover:blur-xl" />
          
          <Link to="/RequestQuotationPage" className="relative block">
            <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md h-16 md:h-20 px-8 md:px-14 text-lg md:text-2xl font-mono uppercase tracking-widest font-bold shadow-xl shadow-primary/10 transition-transform hover:scale-105">
              Request Quote
              <Zap className="ml-3 w-6 h-6 md:w-8 md:h-8 text-secondary" />
            </Button>
          </Link>
        </div>
        
      </div>
    </section>;
}